<template>
	<div id="app">
		<router-view />
	</div>
</template>

<script>
export default {
	name: "App"
};
</script>

<style>
* {
	margin: 0;
	padding: 0;
}

html,
body {
	width: 100%;
	height: 100%;
}

#app {
	font-family: "Avenir", Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
	color: #2c3e50;
	margin: 0;
	padding: 0;
	width: 100%;
	height: 100%;
}

.iconfont {
	margin-right: 7px;
}

.el-popover {
	padding: 0px;
	margin-top: 0 !important;
}

.el-tooltip__popper.is-dark {
	background: whitesmoke;
	padding: 0px;
}

@media screen and (max-width:1000px) {

	.el-popover {
		padding: 0px;
		width: 100% !important;
	}
}
</style>


// WEBPACK FOOTER //
// src/App.vue